var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsApp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 821.513,
    height: 820.181,
    viewBox: "0 0 821.513 820.181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.501,
    y1: 1,
    x2: 0.501,
    y2: 0.002,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_89946",
    x: 0,
    y: 0,
    width: 821.513,
    height: 820.181,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 50,
    dy: 50,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 49.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.722
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.501,
    y1: 1,
    x2: 0.501,
    y2: 0.002,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#20b038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60d66a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WhatsApp",
    transform: "translate(51.975 50.015)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -51.98, -50.02)",
    filter: "url(#Path_89946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89946-2",
    "data-name": "Path 89946",
    d: "M2091.221,2089.656l36-100.178,12.522-42.263s-87.656-153.4,14.087-283.317,289.578-114.266,364.711-43.828,92.352,118.962,97.048,212.879-108,230.1-169.051,225.4c1.565,0-115.831,39.132-192.53,0,4.7,0-28.175-17.218-28.175-17.218Z",
    transform: "translate(-1992.72 -1467.97)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_89943",
    "data-name": "Path 89943",
    d: "M2.325-274.421A267.868,267.868,0,0,0,38.164-140.255L.077-1.187,142.391-38.5A268.387,268.387,0,0,0,270.673-5.84h.12c147.95,0,268.386-120.4,268.447-268.372A266.681,266.681,0,0,0,460.681-464.07a266.756,266.756,0,0,0-189.9-78.708c-147.968,0-268.4,120.386-268.458,268.358",
    transform: "translate(41.304 577.504)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89944",
    "data-name": "Path 89944",
    d: "M2.407-283.847A277.491,277.491,0,0,0,39.524-144.864L.072-.814,147.491-39.468A277.88,277.88,0,0,0,280.376-5.627h.12c153.26,0,278.02-124.724,278.085-277.994A276.306,276.306,0,0,0,477.207-480.3,276.359,276.359,0,0,0,280.5-561.827c-153.285,0-278.028,124.7-278.09,277.98ZM90.2-152.123l-5.5-8.74A230.423,230.423,0,0,1,49.36-283.828c.049-127.4,103.73-231.044,231.224-231.044a229.628,229.628,0,0,1,163.409,67.763A229.646,229.646,0,0,1,511.628-283.64C511.574-156.237,407.889-52.577,280.5-52.577h-.09A230.841,230.841,0,0,1,162.765-84.791l-8.444-5L66.84-66.86Z",
    transform: "translate(31.637 586.837)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89945",
    "data-name": "Path 89945",
    d: "M242.63,186.78c-5.205-11.57-10.684-11.8-15.636-12.006-4.05-.173-8.687-.162-13.316-.162a25.526,25.526,0,0,0-18.527,8.693c-6.37,6.953-24.322,23.761-24.322,57.947s24.9,67.222,28.372,71.862,48.07,77.028,118.694,104.88c58.7,23.146,70.64,18.542,83.38,17.384s41.11-16.8,46.9-33.03,5.791-30.128,4.054-33.035-6.37-4.633-13.319-8.108-41.11-20.287-47.48-22.6-11-3.474-15.635,3.482-17.94,22.6-22,27.23-8.106,5.222-15.056,1.747-29.328-10.815-55.876-34.485c-20.656-18.416-34.6-41.16-38.656-48.116s-.433-10.714,3.052-14.178c3.12-3.113,6.95-8.11,10.424-12.168s4.626-6.953,6.942-11.586,1.158-8.7-.579-12.172-15.241-37.838-21.42-51.576",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/WhatsApp.9cf29134dd915e74605f6e5a250d4a86.svg";
export { ForwardRef as ReactComponent };